import React, { useState, useEffect } from "react";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { isAdminRole, isSuperAdminRole, isGuestRole } from "../../../redux/slices/users";
import IntraverseMiniLogoIcon from "../user/profile/images/ColoredIntraverseLogo.png";
import { default as Button } from "../../../components/common/button/Button";
import { getWindowSize } from "../../../utils/generalUtils";
import { setColor, setFont } from "../../../assets/styles/styles";
import { ReactComponent as UserLogo } from "../user/wallet/images/user_mobile_nav.svg";
import { ReactComponent as CardLogo } from "../user/wallet/images/card_mobile_nav.svg";
import { default as Dropdown } from "../../../components/common/dropdown/Dropdown";
import Chevron from "../../../assets/images/buttonIcons/Chevron.png";
import HamburgerIcon from "../../../assets/images/icons/UC_Sprite_Icon_Menu.png";
import X from "../../../assets/images/buttonIcons/purpleX.png";
import Wave from "../../../assets/images/graphics/UC_Graphic_Wave.png";

const NavigationMenu = () => {
    const user = useSelector((state) => state.user);
    const isAdmin = useSelector(isAdminRole);
    const isSuperAdmin = useSelector(isSuperAdminRole);
    const isGuest = useSelector(isGuestRole);
    const [isOpen, setIsOpen] = useState(false);
    const [activeMobileTab, setActiveMobileTab] = useState("Account");
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const navigate = useNavigate();
    const location = useLocation();

    const routeChange = (path) => {
        navigate(path);
    };

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
    };

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    return (
        <>
            {windowSize.innerWidth > 768 ? (
                <>
                    <DropdownContainer>
                        <ElementContainer>
                            <LogoAndDropDownContainer>
                                <PortalHeaderLogo
                                    isGuest={isGuest}
                                    onClick={() => routeChange("/")}
                                    src={IntraverseMiniLogoIcon}
                                    alt="Intraverse Logo"
                                />
                                {!isGuest && (
                                    <Dropdowns>
                                        <Dropdown
                                            scrollable
                                            maxHeight={80}
                                            title="Account"
                                            items={[
                                                {
                                                    id: 0,
                                                    value: "Profile",
                                                    route: "/console/profile",
                                                },
                                                {
                                                    id: 1,
                                                    value: "My Rooms",
                                                    route: `/console/${user.userId}/my-rooms`,
                                                },
                                                {
                                                    id: 2,
                                                    value: "Wallet",
                                                    route: `/console/wallet`,
                                                },
                                                {
                                                    id: 3,
                                                    value: "Orders",
                                                    route: `/console/orders`,
                                                },
                                                {
                                                    id: 4,
                                                    value: "Guestbook",
                                                    route: `/console/user-guestbook`,
                                                },
                                            ]}
                                        />
                                        {(isAdmin || isSuperAdmin) && (
                                            <>
                                                <Dropdown
                                                    scrollable
                                                    maxHeight={80}
                                                    title="Admin"
                                                    items={[
                                                        {
                                                            id: 11,
                                                            value: "Achievements",
                                                            route: "/console/achievements",
                                                        },
                                                        {
                                                            id: 12,
                                                            value: "Client Tag",
                                                            route: "/console/client_tag",
                                                        },
                                                        {
                                                            id: 6,
                                                            value: "Files",
                                                            route: "/console/files_dashboard",
                                                        },
                                                        {
                                                            id: 8,
                                                            value: "Image Editor",
                                                            route: "/console/image_editor",
                                                        },
                                                        {
                                                            id: 7,
                                                            value: "Merchants",
                                                            route: "/console/merchants",
                                                        },
                                                        {
                                                            id: 10,
                                                            value: "Roles and Permissions",
                                                            route: "/console/roles",
                                                        },
                                                        {
                                                            id: 3,
                                                            value: "Rooms",
                                                            route: "/console/rooms",
                                                        },
                                                        {
                                                            id: 13,
                                                            value: "Room Preset",
                                                            route: "/console/room_preset",
                                                        },
                                                        {
                                                            id: 9,
                                                            value: "Surveys/Forms",
                                                            route: "/console/surveys",
                                                        },
                                                        {
                                                            id: 5,
                                                            value: "Tables",
                                                            route: "/console/tables",
                                                        },

                                                        {
                                                            id: 4,
                                                            value: "Vanity Links",
                                                            route: "/console/vanity-links",
                                                        },
                                                        {
                                                            id: 2,
                                                            value: "Users",
                                                            route: "/console/users",
                                                        },
                                                        {
                                                            id: 1,
                                                            value: "Quest Builder",
                                                            route: "/console/quest-dashboard",
                                                        },
                                                    ]}
                                                />
                                            </>
                                        )}
                                        {user.isUserOwnerOfClient && (
                                            <MenuItem
                                                onClick={() => routeChange("/console/analytics")}
                                                isSelected={location.pathname === "/console/analytics"}
                                            >
                                                Analytics
                                            </MenuItem>
                                        )}
                                    </Dropdowns>
                                )}
                            </LogoAndDropDownContainer>
                            <PortalHeaderMenuButtons>
                                <Button onClick={() => handleLogout()} label="LogOut" variant="TextButton" />
                            </PortalHeaderMenuButtons>
                        </ElementContainer>
                    </DropdownContainer>
                </>
            ) : (
                <>
                    {location.pathname === "/console/user-guestbook" ? (
                        // Existing Mobile Navigation for /console/user-guestbook
                        <MobileNavigation>
                            <MobileTopNav isCenter>
                                <PortalHeaderMenu isOpen={isOpen}>
                                    <PortalHeaderLogo
                                        onClick={() => routeChange("/")}
                                        src={IntraverseMiniLogoIcon}
                                        alt="Intraverse Logo"
                                    />
                                </PortalHeaderMenu>
                                <MobileExit>
                                    <MobileChevron
                                        src={Chevron}
                                        onClick={() => routeChange("/console/profile")}
                                        alt="Exit"
                                    />
                                </MobileExit>
                            </MobileTopNav>
                        </MobileNavigation>
                    ) : (
                        <MobileNavigation>
                            <MobileTopNav>
                                <PortalHeaderLogo
                                    onClick={() => routeChange("/")}
                                    src={IntraverseMiniLogoIcon}
                                    alt="Intraverse Logo"
                                />
                                <HamburgerMenu onClick={() => setIsOpen(!isOpen)} src={HamburgerIcon} alt="Menu" />
                            </MobileTopNav>
                            {isOpen && (
                                <>
                                    <MobileOverlay isOpen={isOpen} />
                                    <MobileMenu>
                                        <MobileMenuTopContainer>
                                            <PortalHeaderLogo
                                                onClick={() => routeChange("/")}
                                                src={IntraverseMiniLogoIcon}
                                                alt="Intraverse Logo"
                                                style={{
                                                    position: "absolute",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    width: "40px",
                                                    height: "27px",
                                                }}
                                            />
                                            <CloseIcon src={X} alt="Close" onClick={() => setIsOpen(!isOpen)} />
                                        </MobileMenuTopContainer>
                                        <MobileMenuContainer>
                                            <MobileMenuWrapper>
                                                {isAdmin || isSuperAdmin ? (
                                                    <>
                                                        <MobileMenuItem
                                                            isSelected={location.pathname === "/console/profile"}
                                                            onClick={() => {
                                                                routeChange("/console/profile");
                                                                setIsOpen(false);
                                                            }}
                                                        >
                                                            Account
                                                        </MobileMenuItem>
                                                        <MobileMenuItem
                                                            isSelected={location.pathname === "/console/users"}
                                                            onClick={() => {
                                                                routeChange("/console/users");
                                                                setIsOpen(false);
                                                            }}
                                                        >
                                                            Admin
                                                        </MobileMenuItem>
                                                        <MobileMenuItem
                                                            onClick={() => {
                                                                routeChange("/console/analytics");
                                                                setIsOpen(false);
                                                            }}
                                                            isSelected={location.pathname === "/console/analytics"}
                                                        >
                                                            Analytics
                                                        </MobileMenuItem>
                                                    </>
                                                ) : (
                                                    <>
                                                        <MobileMenuItem
                                                            isSelected={location.pathname === "/console/profile"}
                                                            onClick={() => {
                                                                routeChange("/console/profile");
                                                                setIsOpen(false);
                                                            }}
                                                        >
                                                            Account
                                                        </MobileMenuItem>

                                                        {/* <MenuItem
                                                            onClick={() => {
                                                                routeChange("/console/users");
                                                                setIsOpen(false);
                                                            }}
                                                        >
                                                            Admin
                                                        </MenuItem> */}
                                                    </>
                                                )}
                                            </MobileMenuWrapper>
                                            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    label="Logout"
                                                    variant="PurpleButton"
                                                    onClick={() => {
                                                        handleLogout();
                                                        setIsOpen(false);
                                                    }}
                                                    backgroundColor={setColor.brightVioletTransparent10}
                                                    margin={"-5px auto"}
                                                    buttonWidth={"90%"}
                                                    buttonMobileWidth={"85%"}
                                                    style={{ margin: "0 auto" }}
                                                />
                                            </div>
                                        </MobileMenuContainer>
                                        <WaveImage src={Wave} alt="Wave" />
                                    </MobileMenu>
                                </>
                            )}
                        </MobileNavigation>
                    )}

                    {/* <MobileFooterNav>
                        <Tab
                            to="/console/profile"
                            isactive={activeMobileTab === "Account"}
                            onClick={() => setActiveMobileTab("Account")}
                        >
                            <NavUserImage isactive={activeMobileTab === "Account"} />
                            Account
                        </Tab>
                        <Tab
                            to="/console/wallet"
                            isactive={activeMobileTab === "Billing"}
                            onClick={() => setActiveMobileTab("Billing")}
                        >
                            <NavCardImage isactive={activeMobileTab === "Billing"} />
                            Billing
                        </Tab>
                        <Tab
                            to="/console/room_personalization"
                            isactive={activeMobileTab === "Customize"}
                            onClick={() => setActiveMobileTab("Customize")}
                        >
                            <NavCardImage isactive={activeMobileTab === "Customize"} />
                            Customize
                        </Tab>
                        <Tab
                            to="/console/rooms"
                            isactive={activeMobileTab === "Rooms"}
                            onClick={() => setActiveMobileTab("Rooms")}
                        >
                            <NavCardImage isactive={activeMobileTab === "Rooms"} />
                            Rooms
                        </Tab>
                    </MobileFooterNav> */}
                </>
            )}
        </>
    );
};

export default NavigationMenu;

const DropdownContainer = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: transparent !important;
    align-items: center;
    width: 100%;
    height: 78px;
    padding: 0 20px;
    z-index: 1;
    border-bottom: 1px solid ${setColor.brightVioletTransparent};
`;

const ElementContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    max-width: 1300px; /* Limit the maximum width */
    padding: 0 20px;
    margin: 0 auto;
`;

const LogoAndDropDownContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

const Dropdowns = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: auto;
    margin: 0 auto;
    margin-top: 23px;
`;

// const NavUserImage = styled(UserLogo)`
//     width: 22px;
//     height: 22px;
//     margin-bottom: 5px;
//     fill: ${(props) => (props.isactive ? setColor.iconColor3 : setColor.iconColor)};
// `;

// const NavCardImage = styled(CardLogo)`
//     width: 22px;
//     height: 22px;
//     margin-bottom: 5px;
//     fill: ${(props) => (props.isactive ? setColor.iconColor3 : setColor.iconColor)};
// `;

// const Tab = styled(NavLink)`
//     text-decoration: auto;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     text-align: center;
//     align-items: center;
//     justify-content: center;

//     color: ${setColor.iconColor};
//     font-family: ${setFont.barlow};
//     font-size: 14px;
//     font-weight: 700;
//     text-transform: uppercase;
//     letter-spacing: 0.1em;

//     ${(props) => {
//         if (props.isactive) {
//             return `
//         color: ${setColor.iconColor3};
//       `;
//         }
//     }}
// `;

// const MobileFooterNav = styled.div`
//     z-index: 1000;
//     position: absolute;
//     bottom: 0;
//     display: flex;
//     justify-content: space-evenly;
//     flex-direction: row;
//     width: 100%;
//     height: 60px;
//     background: none;
//     @media (max-width: 768px) {
//         display: none;
//     }
// `;

const MobileNavigation = styled.div`
    position: sticky;
    width: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    border-bottom: 1px solid ${setColor.brightVioletTransparent};
`;

const MobileTopNav = styled.div`
    position: sticky;
    width: 100%;
    top: 0;
    display: flex;
    justify-content: ${(props) => (props.isCenter ? "center" : "space-between")};
    align-items: center;
    background-color: transparent !important;
    z-index: 1001;
    height: 30px;
    padding: 0 20px;

    @media (max-width: 768px) {
        height: 60px;
    }
`;

// const MobileBottomNav = styled.div`
//     position: sticky;
//     width: 100%;
//     top: 0;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     background-color: transparent !important;
//     z-index: 1000;
//     padding: 0px 40px;

//     @media (max-width: 768px) {
//         padding: 12px 20px;
//     }
// `;

const MobileMenuTopContainer = styled.div`
    width: 100%;
    position: relative;
    padding-bottom: 40px;
    border-bottom: 1px solid ${setColor.brightVioletTransparent};
`;

const MobileMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(100% - 60px);

    @media (max-height: 535px) {
        overflow-y: auto;
    }
`;

const MobileMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
    margin-top: 10px;
`;

const PortalHeaderLogo = styled.img`
    cursor: pointer;
    width: 40px;
    height: 27px;
    margin-left: ${(props) => (props.isGuest ? "-50rem" : "0rem")};

    @media (min-width: 768px) and (max-width: 1024px) {
        max-width: 80px;
        margin-left: 0rem;
    }
`;

const PortalHeaderMenu = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    margin: 0;
    background-color: transparent !important;
`;

const PortalHeaderMenuButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0;
    width: 100%;
    height: 100%;
    margin-left: auto;
    border-right: 1px solid ${setColor.brightVioletTransparent};
    border-left: 1px solid ${setColor.brightVioletTransparent};
    padding-left: 10px;
    padding-right: 10px;

    position: relative;

    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: ${setColor.brightVioletTransparent};
    }

    &::before {
        left: 0;
    }

    &::after {
        right: 0;
    }

    @media (max-width: 768px) {
        margin: 0px;
        display: none;
    }
`;

const MobileExit = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 25%;
    width: 40px;
    height: 40px;
    z-index: 1000;
    padding: 10px;
`;

const MobileChevron = styled.div`
    background-image: url(${Chevron});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 20px;
    height: 20px;
`;

const MenuItem = styled.div`
    // padding: 10px 8px;
    // padding-top: 0px;
    padding-bottom: 17px;
    color: ${(props) => (props.isSelected ? setColor.iconColor3 : "#9D9D9D")};
    border-bottom: ${(props) => `6px solid ${props.isSelected ? setColor.iconColor3 : "transparent"}`};
    font-family: ${setFont.barlow};
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
    text-align: center;
    width: fit-content;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        color: ${setColor.accent4};
    }

    &:first-child {
        background-color: transparent;
        justify-content: flex-start;
    }
`;

const MobileMenu = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 45vh;
    background: ${setColor.linearPurple};
    border-bottom: "1px solid ${setColor.brightVioletTransparent}";
    z-index: 1002;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    border-radius: 0 0 10px 10px;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: 1px solid rgba(157, 117, 245, 0.3);
    }

    @media (max-height: 600px) {
        height: 65vh;
    }
    @media (max-height: 460px) {
        height: 90vh;
    }
`;

const MobileMenuItem = styled.div`
    padding: 10px 20px;
    color: ${(props) => (props.isSelected ? setColor.brightViolet100 : "rgba(255, 255, 255, 0.5)")};
    font-family: ${(props) => (props.isSelected ? setFont.barlow : setFont.marlow)};
    font-size: 24px;
    font-weight: ${(props) => (props.isSelected ? "700" : "500")};
    font-style: normal;
    line-height: normal;
    text-transform: capitalize;
    cursor: pointer;
    text-align: center;
    width: 90%;
    border-radius: 5px;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: ${setColor.brightVioletTransparent};
    }

    &:first-child {
        background-color: transparent;
        justify-content: flex-start;
    }
`;

const MobileOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1001;
    display: ${(props) => (props.isOpen ? "block" : "none")};
`;

const CloseIcon = styled.img`
    position: absolute;
    right: 15px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1003;
`;

const HamburgerMenu = styled.img`
    width: 30px;
    height: 30px;
    cursor: pointer;
    // margin-top: 30px;
    padding: 8px;
    background-color: ${setColor.brightVioletTransparent10};
    border-radius: 7px;
    box-sizing: content-box;
`;

const WaveImage = styled.div`
    position: absolute;
    bottom: 0;
    left: 65%;
    width: 40%;
    height: 80%;
    background: url(${Wave}) no-repeat center bottom;
    background-size: cover;
    z-index: 999;

    @media (max-width: 768px) {
        display: block;
        left: 73%;
    }
`;
